export default {
  FETCH_RESERVATION_INVOICE_DETAILS_LOADING:
    'FETCH_RESERVATION_INVOICE_DETAILS_LOADING',
  FETCH_RESERVATION_INVOICE_DETAILS_REJECT:
    'FETCH_RESERVATION_INVOICE_DETAILS_REJECT',
  FETCH_RESERVATION_INVOICE_DETAILS_FAILED:
    'FETCH_RESERVATION_INVOICE_DETAILS_FAILED',
  FETCH_RESERVATION_INVOICE_DETAILS_SUCCESS:
    'FETCH_RESERVATION_INVOICE_DETAILS_SUCCESS',

  FETCH_RESERVATION_TEMPORARY_PRINT_LOADING:
    'FETCH_RESERVATION_TEMPORARY_PRINT_LOADING',
  FETCH_RESERVATION_TEMPORARY_PRINT_REJECT:
    'FETCH_RESERVATION_TEMPORARY_PRINT_REJECT',
  FETCH_RESERVATION_TEMPORARY_PRINT_FAILED:
    'FETCH_RESERVATION_TEMPORARY_PRINT_FAILED',
  FETCH_RESERVATION_TEMPORARY_PRINT_SUCCESS:
    'FETCH_RESERVATION_TEMPORARY_PRINT_SUCCESS',

  FETCH_RESERVATION_FACTOR_PRINT_LOADING:
    'FETCH_RESERVATION_FACTOR_PRINT_LOADING',
  FETCH_RESERVATION_FACTOR_PRINT_REJECT:
    'FETCH_RESERVATION_FACTOR_PRINT_REJECT',
  FETCH_RESERVATION_FACTOR_PRINT_FAILED:
    'FETCH_RESERVATION_FACTOR_PRINT_FAILED',
  FETCH_RESERVATION_FACTOR_PRINT_SUCCESS:
    'FETCH_RESERVATION_FACTOR_PRINT_SUCCESS',

  FETCH_RESERVATION_REQUESTS_LOADING: 'FETCH_RESERVATION_REQUESTS_LOADING',
  FETCH_RESERVATION_REQUESTS_REJECT: 'FETCH_RESERVATION_REQUESTS_REJECT',
  FETCH_RESERVATION_REQUESTS_FAILED: 'FETCH_RESERVATION_REQUESTS_FAILED',
  FETCH_RESERVATION_REQUESTS_SUCCESS: 'FETCH_RESERVATION_REQUESTS_SUCCESS',

  FETCH_INCOMING_RESERVATIONS_LOADING: 'FETCH_INCOMING_RESERVATIONS_LOADING',
  FETCH_INCOMING_RESERVATIONS_REJECT: 'FETCH_INCOMING_RESERVATIONS_REJECT',
  FETCH_INCOMING_RESERVATIONS_FAILED: 'FETCH_INCOMING_RESERVATIONS_FAILED',
  FETCH_INCOMING_RESERVATIONS_SUCCESS: 'FETCH_INCOMING_RESERVATIONS_SUCCESS',

  FETCH_TABLE_NUMBERS_LOADING: 'FETCH_TABLE_NUMBERS_LOADING',
  FETCH_TABLE_NUMBERS_REJECT: 'FETCH_TABLE_NUMBERS_REJECT',
  FETCH_TABLE_NUMBERS_FAILED: 'FETCH_TABLE_NUMBERS_FAILED',
  FETCH_TABLE_NUMBERS_SUCCESS: 'FETCH_TABLE_NUMBERS_SUCCESS',

  START_RESERVATION_LOADING: 'START_RESERVATION_LOADING',
  START_RESERVATION_REJECT: 'START_RESERVATION_REJECT',
  START_RESERVATION_FAILED: 'START_RESERVATION_FAILED',
  START_RESERVATION_SUCCESS: 'START_RESERVATION_SUCCESS',

  FETCH_ALL_CAFE_RESERVATIONS_LOADING: 'FETCH_ALL_CAFE_RESERVATIONS_LOADING',
  FETCH_ALL_CAFE_RESERVATIONS_REJECT: 'FETCH_ALL_CAFE_RESERVATIONS_REJECT',
  FETCH_ALL_CAFE_RESERVATIONS_FAILED: 'FETCH_ALL_CAFE_RESERVATIONS_FAILED',
  FETCH_ALL_CAFE_RESERVATIONS_SUCCESS: 'FETCH_ALL_CAFE_RESERVATIONS_SUCCESS',

  FETCH_CAFE_RESERVATION_DETAILS_LOADING:
    'FETCH_CAFE_RESERVATION_DETAILS_LOADING',
  FETCH_CAFE_RESERVATION_DETAILS_REJECT:
    'FETCH_CAFE_RESERVATION_DETAILS_REJECT',
  FETCH_CAFE_RESERVATION_DETAILS_FAILED:
    'FETCH_CAFE_RESERVATION_DETAILS_FAILED',
  FETCH_CAFE_RESERVATION_DETAILS_SUCCESS:
    'FETCH_CAFE_RESERVATION_DETAILS_SUCCESS',

  EDIT_CAFE_RESERVATION_STATUS_LOADING: 'EDIT_CAFE_RESERVATION_STATUS_LOADING',
  EDIT_CAFE_RESERVATION_STATUS_REJECT: 'EDIT_CAFE_RESERVATION_STATUS_REJECT',
  EDIT_CAFE_RESERVATION_STATUS_FAILED: 'EDIT_CAFE_RESERVATION_STATUS_FAILED',
  EDIT_CAFE_RESERVATION_STATUS_SUCCESS: 'EDIT_CAFE_RESERVATION_STATUS_SUCCESS',

  USER_RESERVATIONS_LOADING: 'USER_RESERVATIONS_LOADING',
  USER_RESERVATIONS_REJECT: 'USER_RESERVATIONS_REJECT',
  USER_RESERVATIONS_FAILED: 'USER_RESERVATIONS_FAILED',
  USER_RESERVATIONS_SUCCESS: 'USER_RESERVATIONS_SUCCESS',

  FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_LOADING:
    'FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_LOADING',
  FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_REJECT:
    'FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_REJECT',
  FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_FAILED:
    'FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_FAILED',
  FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_SUCCESS:
    'FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_SUCCESS',

  FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_LOADING:
    'FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_LOADING',
  FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_REJECT:
    'FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_REJECT',
  FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_FAILED:
    'FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_FAILED',
  FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_SUCCESS:
    'FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_SUCCESS',

  CHECKOUT_CAFE_RESERVES_LOADING: 'CHECKOUT_CAFE_RESERVES_LOADING',
  CHECKOUT_CAFE_RESERVES_REJECT: 'CHECKOUT_CAFE_RESERVES_REJECT',
  CHECKOUT_CAFE_RESERVES_FAILED: 'CHECKOUT_CAFE_RESERVES_FAILED',
  CHECKOUT_CAFE_RESERVES_SUCCESS: 'CHECKOUT_CAFE_RESERVES_SUCCESS',

  FETCH_CHECKOUT_DETAILS_LOADING: 'FETCH_CHECKOUT_DETAILS_LOADING',
  FETCH_CHECKOUT_DETAILS_REJECT: 'FETCH_CHECKOUT_DETAILS_REJECT',
  FETCH_CHECKOUT_DETAILS_FAILED: 'FETCH_CHECKOUT_DETAILS_FAILED',
  FETCH_CHECKOUT_DETAILS_SUCCESS: 'FETCH_CHECKOUT_DETAILS_SUCCESS',

  FINAL_CHECKOUT_CAFE_RESERVES_LOADING: 'FINAL_CHECKOUT_CAFE_RESERVES_LOADING',
  FINAL_CHECKOUT_CAFE_RESERVES_REJECT: 'FINAL_CHECKOUT_CAFE_RESERVES_REJECT',
  FINAL_CHECKOUT_CAFE_RESERVES_FAILED: 'FINAL_CHECKOUT_CAFE_RESERVES_FAILED',
  FINAL_CHECKOUT_CAFE_RESERVES_SUCCESS: 'FINAL_CHECKOUT_CAFE_RESERVES_SUCCESS',

  FETCH_INCOMING_SCHEMATIC_RESERVATION_LOADING:
    'FETCH_INCOMING_SCHEMATIC_RESERVATION_LOADING',
  FETCH_INCOMING_SCHEMATIC_RESERVATION_REJECT:
    'FETCH_INCOMING_SCHEMATIC_RESERVATION_REJECT',
  FETCH_INCOMING_SCHEMATIC_RESERVATION_FAILED:
    'FETCH_INCOMING_SCHEMATIC_RESERVATION_FAILED',
  FETCH_INCOMING_SCHEMATIC_RESERVATION_SUCCESS:
    'FETCH_INCOMING_SCHEMATIC_RESERVATION_SUCCESS',
  FETCH_RESERVATION_PRINT_DATA_SUCCESS: 'FETCH_RESERVATION_PRINT_DATA_SUCCESS',
};
